/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export const replaceBrandMentions = (text, installationName) => {
  if (!text || !installationName) return text;

  const withLatinBrand = text.replace(
    /\bchatwoot\b/gi,
    (match, offset, source) => {
      const previousCharacter = source[offset - 1];
      const nextCharacter = source[offset + match.length];
      const isDomain = previousCharacter === '.' || nextCharacter === '.';

      return isDomain ? match : installationName;
    }
  );

  return withLatinBrand.replace(/чатвут/gi, installationName);
};

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" (any casing) in text with the installation name from
   * global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = globalConfig.value?.installationName;
    if (!installationName) return text;

    return replaceBrandMentions(text, installationName);
  };

  return {
    replaceInstallationName,
  };
}
